var exports = {
  "R": "x31de4314--c79325--branding-level-wrapper",
  "X": "x31de4314--c79325--platinum",
};

module.exports = exports;
